package model

import kotlinx.serialization.Serializable

@Serializable
data class PaymentsAndMerchantInformation(
    val merchantFullInformationV3: MerchantFullInformationV3,
    val payments: Payments,
)
